import { Component } from 'react';
import 'antd/dist/antd.css';
import { Spinner } from 'reactstrap';
import axios from '../../utils/request';
import {Result,message } from 'antd';
import React from 'react';


let tenantId = "";
export class ZjwjPush extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isReady: false,
            isLoading: true,
            msg: "",
            tenantId: "",
            userId: "",
            commonParamater: "",
            errorMessage:""
        }
    };

  
    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        let commonParamater = urlParams.get("commonParamater");
        tenantId = urlParams.get("tenantId");
       
        if (!commonParamater) {
            this.setState({ msg: "未能获取基本参数！", isLoading: false, isReady: true });
            return;
        }
        console.log("标准系统参数", commonParamater, tenantId);
        this.state.commonParamater = commonParamater;
        this.state.tenantId = tenantId;
        this.loadPage(tenantId, commonParamater);
        //this.loadPage(430585, "1246375d-34e8-4a0d-897d-613010ccf01d");
    };

    loadPage = (tenantId, commonParamater) => {
        const params = {
            tenantId,
            commonParamater
        }
        axios
            .get("/api/ZJWJ/GetRequirements", { params: params })
            .then(res => {
                console.log("中建五局请求结果", res);
                let resMessage = "";

                if (res.status == 200 && res.data.code == "200") {
                    resMessage = res.data.data;
                }
                else {
                    resMessage = "获取数据失败，请联系管理员";
                }
                this.setState({ isLoading: false, isReady: true, msg: resMessage });
            })
            .catch(reason => {
                console.log(reason);
                this.setState({ isLoading: false, isReady: true, msg: "操作异常，请联系管理员！" });
            })
            .finally(
            );
    };

    render() {
        if (this.state.isReady) {
       
            if (this.state.msg == "成功发起，后续执行结果见消息通知") {
                //return message.success({ content: showMsg, style: { fontSize: 20, marginTop: '20vh', :'5vh' }, duration: 0 });
                return (<Result
                    status="success"
                    key="wish"
                    extra={[
                        <br key="br1" />,
                        <p key="p1" style={{ textAlign: "center", fontSize: "17px", marginRight: "0" }}>{this.state.msg}</p>
                    ]}

                />)
            } else {
                return (<Result
                    status="warning"
                    key="wish"
                    extra={[
                        <br key="br1" />,
                        <p key="p1" style={{ textAlign: "center", fontSize: "17px", marginRight: "0" }}>{this.state.msg}</p>
                    ]}

                />)
            }         
        }
        else {
            return (
                <div style={{ textAlign: "center", padding: "15px", opacity:1 }}>
                    <Spinner type="grow" color="primary" />
                    <Spinner type="grow" color="secondary" />
                    <Spinner type="grow" color="success" />
                    <Spinner type="grow" color="danger" />
                    <Spinner type="grow" color="warning" />
                    <Spinner type="grow" color="info" />
                    <Spinner type="grow" color="dark" />
                </div>
            );
        }

    }
}